
import { Form, Input } from 'decorator-form';

import InputType from 'common/form/InputType';
import { BlockStylesConfig, blockStylesInput } from '../common/BlockStylesConfig';
import { TypographyStylesConfig, typographyStylesInput } from '../common/TypographyStylesConfig';

@Form({title: "Button View Config"})
export default class ButtonConfig {

	// transition
	@Input({type: InputType.TEXT, title: "Transition"})
	public transition: string = "0.2s ease-in-out";

	@Input({type: InputType.CHECKBOX, title: "Block"})
	public block: boolean = false;

	@Input({type: typographyStylesInput, title: "Text Styles"})
	public typography: TypographyStylesConfig;

	@Input({type: blockStylesInput, title: "Default State"})
	public defaultState: BlockStylesConfig;

	@Input({type: blockStylesInput, title: "Hover State"})
	public hoverState: BlockStylesConfig;

	@Input({type: blockStylesInput, title: "Active State"})
	public activeState: BlockStylesConfig;

	@Input({type: blockStylesInput, title: "Disabled State"})
	public disabledState: BlockStylesConfig;

	@Input({type: InputType.TEXT, title: "Icon class (bp)"})
	public iconClass: string;

}



// WEBPACK FOOTER //
// ./src/common/views/button/ButtonConfig.ts